export const isToyotaFleetPortal = () => {
    return window.location.href.includes('fleetportal');
};
